import React from "react";
import Servicios from "./Servicios";
import Nosotros from "./Nosotros";
import Contacto from "./Contacto";
import Emprendedores from "./Emprendedores";

export default () => {
  return (
    <>
      <Nosotros />
      <Servicios />
      <Emprendedores />
      <Contacto />
    </>
  );
};
